<template>
  <div class="header">
    <div class="header-box">
      <div class="header-left">
        <img class="logo" src="../assets/images/logo.jpg" @click="$router.push({name: 'Home'})">
      </div>
      <div class="header-nav">
        <div class="header-nav-item" @click="goPage('Home')">事件</div>
        <div class="header-nav-item active" v-if="navName">{{navName}}</div>
      </div>
      <div class="header-right">
        <Dropdown placement="bottom-start"  v-if="hasLogin">
          <div class="user-info">
<!--            <img class="avatar" src="../assets/images/avatar.png" alt="">-->
            <div class="name">{{UserData.user_name || '---'}}</div>
            <div class="mail"><Icon size="20" type="md-person" />{{UserData.email || '---'}}<Icon class="dropdown"  size="18" type="md-arrow-dropdown" /></div>
          </div>
          <DropdownMenu slot="list" >
            <DropdownItem name="1" >{{UserData.email || '---'}}</DropdownItem>
            <DropdownItem name="2" @click.native="logout()">退出登录</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <div class="user-info" v-else>
          <img class="avatar" src="../assets/images/avatar.png" alt="">
          <span @click="$router.push({name: 'Login'})">立即登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Core from '@/until/core'
import { mapGetters } from 'vuex'

export default {
  name: 'MainHeader',
  props: {
    // navList: {
    //   type: Array,
    //   default: null
    // }
    navName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'UserData'
    ]),
    hasLogin () {
      return this.$store.state.hasLogin
    }
  },
  methods: {
    goPage (name) {
      this.$router.push({name})
    },
    logout () {
      Core.removeCookie()
      this.$router.push({
        name: 'Login'
      })
    }
  },
  mounted () {
    // this.logout()
  }
}
</script>

<style scoped>
  /*.header{position: fixed; top: 0; left: 0; width: 100%; height: 66px;background: #fff;  box-shadow: 0 1px 1px rgba(0,0,0,.08); padding: 0 30px; box-sizing: border-box; z-index: 99}*/
  .header{position: fixed; top: 0; left: 0; width: 100%; height: 66px; padding: 0 30px; box-sizing: border-box; z-index: 99; background: rgb(239, 240, 242)}
  .header-box{min-width: 800px; max-width: 1200px; padding: 0; margin: 0 auto; }
  .header-left{float: left}
  .header-left .logo{width: 46px; height: 46px; margin-top: 10px}
  .header-nav{float: left; display: flex; margin-left: 20px;}
  .header-nav-item{line-height: 66px; padding: 0 20px; color: #2d8cf0; cursor: pointer}
  .header-nav-item.active{color: #808695; background: #fff}
  .header-right{float: right}
  .user-info{height: 66px;  cursor: pointer; text-align: right; padding-top: 10px;position: relative}
  .avatar{width: 32px; height: 32px; border-radius: 16px; vertical-align: center}
  .user-info .dropdown{position: absolute; top: 35px}
  .user-info .name{}
  .user-info .mail{color: #378248; font-weight: bold}
  .login-text{line-height: 50px}
</style>



// WEBPACK FOOTER //
// src/public/MainHeader.vue